import Storage from '@comm/utils/storagehandle'
import apis from '@comm/http/api.js'
const user = {
  namespaced: true,
  state: {
    loginUrl: Storage.getItem('loginUrl') || null, // 登录之前记录的url,
    isLogin: false,
    isBind: Storage.getItem('isBind') || 0, //  登录的账户信息是否绑定了手机号码
    userInfo: Storage.getItem('userInfo') || null, //  登录的账户信息
    accountId: Storage.getItem('accountId') || null,
    nickName: Storage.getItem('nickName') || null,
    accessToken: Storage.getItem('accessToken') || '',
    refreshToken: Storage.getItem('refreshToken') || '',
    expiresIn: Storage.getItem('expiresIn') || 0,
    timeStamp: Storage.getItem('timeStamp') || 0
  },
  mutations: {
    'USER_CHANGE_LOGIN_URL' (state, loginUrl) {
      state.loginUrl = loginUrl
      Storage.setItem('loginUrl', state.loginUrl)
    },
    'USER_CHANGE_IS_LOGIN' (state, isLogin) {
      state.isLogin = isLogin
    },
    'USER_CHANGE_IS_BIND' (state, isBind) {
      state.isBind = isBind
      Storage.setItem('isBind', state.isBind)
    },
    'USER_CHANGE_USER_INFO' (state, userInfo) {
      state.userInfo = userInfo
      Storage.setItem('userInfo', state.userInfo)
    },
    'USER_CHANGE_ACCOUNT_ID' (state, accountId) {
      state.accountId = accountId
      Storage.setItem('accountId', state.accountId)
    },
    'USER_CHANGE_NICK_NAME' (state, nickName) {
      state.nickName = nickName
      Storage.setItem('nickName', state.nickName)
    },
    'USER_CHANGE_ACCESS_TOKEN' (state, accessToken) {
      state.accessToken = accessToken
      Storage.setItem('accessToken', state.accessToken)
    },
    'USER_CHANGE_REFRESH_TOKEN' (state, refreshToken) {
      state.refreshToken = refreshToken
      Storage.setItem('refreshToken', state.refreshToken)
    },
    'USER_CHANGE_EXPIRES_IN' (state, expiresIn) {
      state.expiresIn = expiresIn
      Storage.setItem('expiresIn', state.expiresIn)
    },
    'USER_CHANGE_TIME_STAMP' (state, timeStamp) {
      state.timeStamp = timeStamp
      Storage.setItem('timeStamp', state.timeStamp)
    }
  },
  actions: {
    /**
     * 用户登录
     * @param {*} param0 , context 状态管理上下文对象,{commit,state,dispatch}
     * @param {*} valDate
     */
    Login ({ commit }, valDate) {
      return new Promise((resolve, reject) => {
        apis.user.oauthToken(valDate).then(response => {
          if (response.status > 0) {
            reject(response.msg)
            return
          }
          apis.user.userInfo(valDate).then(info => {
            if (info.status === 0) {
              commit('USER_CHANGE_USER_INFO', info.data)
            }
          })
          commit('USER_CHANGE_ACCOUNT_ID', response.data.userId)
          commit('USER_CHANGE_IS_BIND', response.data.isBind === undefined ? 1 : response.data.isBind)
          commit('USER_CHANGE_NICK_NAME', response.data.nickname)
          commit('USER_CHANGE_ACCESS_TOKEN', response.data.access_token)
          commit('USER_CHANGE_REFRESH_TOKEN', response.data.refresh_token)
          commit('USER_CHANGE_EXPIRES_IN', response.data.expires_in)
          // 记录一个当前时间戳
          commit('USER_CHANGE_TIME_STAMP', Date.parse(new Date()))
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 退出登录
     * @param {*} param0 , context 状态管理上下文对象,{commit,state,dispatch}
     */
    Logout ({ commit }) {
      return new Promise((resolve) => {
        apis.user.oauthLogout({}).then(() => {
          commit('USER_CHANGE_ACCESS_TOKEN', '')
          commit('USER_CHANGE_IS_BIND', 0)
          commit('USER_CHANGE_USER_INFO', null)
          commit('USER_CHANGE_ACCOUNT_ID', null)
          commit('USER_CHANGE_NICK_NAME', null)
          commit('USER_CHANGE_REFRESH_TOKEN', '')
          commit('USER_CHANGE_EXPIRES_IN', '')
          // 记录一个当前时间戳
          commit('USER_CHANGE_TIME_STAMP', 0)
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    }
  },
  getters: {
    loginUrl: state => state.loginUrl,
    isLogin: state => state.isLogin,
    userInfo: state => state.userInfo,
    isBind: state => state.isBind,
    accountId: state => state.accountId,
    nickName: state => state.nickName,
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    expiresIn: state => state.expiresIn,
    timeStamp: state => state.timeStamp
  }
}
export default user



// WEBPACK FOOTER //
// ./src/daoba-match/store/modules/user.js